import {
  REQUEST_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_NO_COOKIE_SET,
  LOGIN_ERROR,
  REQUEST_LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  REQUEST_GOOGLELOGIN,
  GOOGLELOGIN_SUCCESS,
  REQUEST_GOOGLELOGOUT,
  GOOGLELOGOUT_SUCCESS,
  REQUEST_ISADMIN,
  ISADMIN_SUCCESS,
  REQUEST_ACTIVE_DIRECTORY_LOGIN,
  LOGIN_ACTIVE_DIRECTORY_SUCCESS,
  LOGIN_ACTIVE_DIRECTORY_ERROR,
  ISADMIN_ERROR,
} from "../actions";

const initialState = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isLoadingReducer = (state = initialState, action: any = null) => {
  switch (action.type) {
    case REQUEST_LOGIN:
    case REQUEST_LOGOUT:
    case REQUEST_GOOGLELOGIN:
    case REQUEST_GOOGLELOGOUT:
    case REQUEST_ISADMIN:
    case REQUEST_ACTIVE_DIRECTORY_LOGIN:
      return true;
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case GOOGLELOGIN_SUCCESS:
    case GOOGLELOGOUT_SUCCESS:
    case ISADMIN_SUCCESS:
    case LOGIN_NO_COOKIE_SET:
    case LOGIN_ERROR:
    case LOGOUT_ERROR:
    case ISADMIN_ERROR:
    case LOGIN_ACTIVE_DIRECTORY_SUCCESS:
    case LOGIN_ACTIVE_DIRECTORY_ERROR:
      return false;
    default:
      return state;
  }
};

export default isLoadingReducer;
